export default {
  requestTimeoutMs: 30000,
  requestTimeoutErrorMessage: 'Request timeout'
};
